import { MotionValue } from 'framer-motion';
import { DynamicIcon } from 'src/components';
import {
  SwipeAction,
  SwipeActionKind,
} from 'src/pages/CustomViews/custom-views-mobile-card-list/card-swipe.types';
import {
  SwipeActionButton,
  SwipeTray,
} from 'src/pages/CustomViews/custom-views-mobile-card-list/mobile-card-list.elements';

export const CardSwipeTray = ({
  width,
  actions,
  isOpen,
  onAction,
}: {
  width: MotionValue<number>;
  actions: SwipeAction[];
  isOpen: boolean;
  onAction: (kind: SwipeActionKind) => void;
}) => (
  // a closed tray is zero-width but still in the DOM, so it leaves the tab order and the a11y tree
  <SwipeTray
    style={{ width }}
    aria-hidden={!isOpen}
    data-testid="custom-views-mobile-card-swipe-tray"
  >
    {actions.map((action) => (
      <SwipeActionButton
        key={action.kind}
        kind={action.kind}
        tabIndex={isOpen ? 0 : -1}
        onClick={() => onAction(action.kind)}
        data-testid={`custom-views-mobile-card-swipe-${action.kind}`}
      >
        <DynamicIcon name={action.icon} library="lucide" />
        <span>{action.label}</span>
      </SwipeActionButton>
    ))}
  </SwipeTray>
);
